'use client';
import { createContext, FC, useContext } from 'react';
import { TypeEmptyDirective } from '@/core/generated-types';

interface EmptyDirectiveContextValue {
  emptyDirective: TypeEmptyDirective;
}

interface EmptyDirectiveProps {
  children: any;
  emptyDirective: TypeEmptyDirective;
}

const EmptyDirectiveContext = createContext({} as EmptyDirectiveContextValue);

export const useEmptyDirective = () => useContext(EmptyDirectiveContext);

export const EmptyDirectiveProvider: FC<EmptyDirectiveProps> = ({
  emptyDirective,
  children,
}) => {
  const emptyContextValue = {
    emptyDirective,
  };

  return (
    <EmptyDirectiveContext.Provider value={emptyContextValue}>
      {children}
    </EmptyDirectiveContext.Provider>
  );
};
